module.exports = __webpack_public_path__ + "static/media/Muli-Regular.3fd392fb.woff";